import { useLang } from "../contexts/LanguageContext";
import locales from "../utils/locales";
import { useEffect, useState } from "react";

export default function LifeCountdownBar({ currentAge, targetAge, loading }) {
  const { lang } = useLang();
  const t = locales[lang];
  const stickyClass = "sticky top-10 z-40";

  // --- Real-time countdown state ---
  const [hoursLeft, setHoursLeft] = useState(null);

  useEffect(() => {
    if (
      loading ||
      currentAge === null ||
      targetAge === null ||
      isNaN(currentAge) ||
      isNaN(targetAge) ||
      targetAge <= currentAge
    ) {
      setHoursLeft(null);
      return;
    }

    function calcHoursLeft() {
      const now = new Date();
      // ใช้ birthYear เป็น anchor คงที่ → target date ไม่เปลี่ยนทุกครั้งที่เปิด app
      const birthYear = now.getFullYear() - currentAge;
      const targetDate = new Date(birthYear + targetAge, 6, 1); // 1 ก.ค. ของปีเป้าหมาย
      const diffMs = targetDate - now;
      setHoursLeft(diffMs > 0 ? diffMs / (1000 * 60 * 60) : 0);
    }

    calcHoursLeft();
    const interval = setInterval(calcHoursLeft, 1000); // อัปเดตทุกวินาที
    return () => clearInterval(interval);
  }, [currentAge, targetAge, loading]);

  // --- Loading/Pending UI ---
  if (loading) {
    return (
      <div className={`w-full bg-yellow-50 text-center py-1 text-sm font-semibold text-purple-800 shadow ${stickyClass}`}>
        <div className="flex flex-col items-center py-2">
          <div className="w-6 h-6 rounded-full bg-purple-300 animate-pulse mb-1"></div>
          <div className="text-xs text-purple-700 font-medium">
            {lang === "th"
              ? "กำลังเตรียมข้อมูลชีวิต..."
              : "Preparing your journey..."}
          </div>
        </div>
      </div>
    );
  }

  // ----------- ยังไม่ตั้งค่าอายุ หรือข้อมูลไม่ครบ -----------
  if (hoursLeft === null || currentAge === null || targetAge === null) {
    return (
      <div className={`w-full bg-yellow-50 text-center py-2 text-sm font-semibold text-purple-800 shadow flex flex-col items-center gap-1 ${stickyClass}`}>
        <div className="w-6 h-6 rounded-full bg-gray-300 animate-bounce mb-1"></div>
        <div>
          {lang === "th"
            ? "ตั้งค่าอายุของคุณในเมนู More เพื่อดูเวลาชีวิตที่เหลือ"
            : "Set up your age in More to see your life countdown"}
        </div>
      </div>
    );
  }

  // ------------- แสดงค่าจริง (แบบ realtime) --------------
  return (
    <div className={`w-full bg-yellow-50 text-center py-1 text-sm font-semibold text-purple-800 shadow ${stickyClass}`}>
      {t.hours_left
        .replace("{hours}", hoursLeft.toLocaleString(undefined, { maximumFractionDigits: 2 }))
        .replace("{cur}", currentAge)
        .replace("{target}", targetAge)}
    </div>
  );
}